import './AnnotationControlButton.css'
import React from 'react'
import classnames from 'classnames'

export default function AnnotationControlButton({
  ariaLabel,
  controlMode,
  currentControlMode,
  onClick,
  tooltip,
  children,
}) {
  const classes = classnames('AnnotationControlButton', {
    selected: currentControlMode === controlMode,
  })
  return (
    <button
      key="point"
      aria-label={ariaLabel}
      className={classes}
      onClick={onClick}
      title={tooltip}
    >
      <div className="AnnotationControlButton-outer">
        <div className="AnnotationControlButton-inner">{children}</div>
      </div>
    </button>
  )
}
